export const BOOKING_APP_URL = "https://api.samasportshub.in/";
//export const BOOKING_APP_URL = "http://localhost:3001/";
export const HUB_ID = 2;
export const userType = 'admin';
export const endTimeID = 24;
export const endTimeName = '11 PM';

